
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Syringomyelia",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Syringomyelia.vue